import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateTableView, ITableView, TableViewListResponse, TableViewQueryParams, UpdateTableView } from '@frontend/user/types';

export class TableViewClient extends APIClient {
    public static readonly myEndpoint = '/user-api/my/v1';
    private static readonly fetchMyTableViewsRequests = new Map<string, Promise<TableViewListResponse>>();

    public static async fetchMyTableViews(queryParams?: ApiQueryParams<DefaultQueryParams | TableViewQueryParams>): Promise<TableViewListResponse> {
        const requestKey = tableViewRequestKey(queryParams);
        const existingRequest = this.fetchMyTableViewsRequests.get(requestKey);
        if (existingRequest) return existingRequest;

        const request = this.apiPaginated<TableViewListResponse, DefaultQueryParams | TableViewQueryParams>(
            `${this.myEndpoint}/table-views`,
            queryParams
        ).finally(() => {
            this.fetchMyTableViewsRequests.delete(requestKey);
        });

        this.fetchMyTableViewsRequests.set(requestKey, request);
        return request;
    }

    public static async fetchMyTableView(tableId: string): Promise<ITableView | null> {
        const response = await this.fetchMyTableViews({ [TableViewQueryParams.TABLE_ID]: tableId });
        return response.results.find((view) => view.table_id === tableId) ?? null;
    }

    public static async postMyTableView(tableView: CreateTableView): Promise<ITableView> {
        const response = await this.post(`${this.myEndpoint}/table-views`, tableView);
        return await this.handleResponse<ITableView>(response);
    }

    public static async patchMyTableView(viewId: string, tableView: UpdateTableView): Promise<ITableView> {
        const response = await this.patch(`${this.myEndpoint}/table-views/${viewId}`, tableView);
        return await this.handleResponse<ITableView>(response);
    }

    public static async deleteMyTableView(viewId: string): Promise<void> {
        const response = await this.delete(`${this.myEndpoint}/table-views/${viewId}`);
        return await this.handleVoidResponse(response);
    }
}

const tableViewRequestKey = (queryParams?: ApiQueryParams<DefaultQueryParams | TableViewQueryParams>): string => JSON.stringify(queryParams ?? {});
